module.exports = __webpack_public_path__ + "img/bg.626361aa.jpg";